import { render, staticRenderFns } from "./claimsform.vue?vue&type=template&id=19561d30&scoped=true&"
import script from "./claimsform.vue?vue&type=script&lang=ts&"
export * from "./claimsform.vue?vue&type=script&lang=ts&"
import style0 from "./claimsform.vue?vue&type=style&index=0&id=19561d30&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19561d30",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Modal: require('/opt/atlassian/pipelines/agent/build/components/Modal.vue').default})
